import {
  FETCH_ER_UNITS_REQUEST,
  FETCH_ER_UNITS_SUCCESS,
  FETCH_ER_UNITS_FAILURE,
  FETCH_ER_FAB_TYPES_REQUEST,
  FETCH_ER_FAB_TYPES_SUCCESS,
  FETCH_ER_FAB_TYPES_FAILURE,
  FETCH_ER_WEIGHTS_REQUEST,
  FETCH_ER_WEIGHTS_SUCCESS,
  FETCH_ER_WEIGHTS_FAILURE,
  FETCH_ER_UNIT_FABRICATIONS_REQUEST,
  FETCH_ER_UNIT_FABRICATIONS_SUCCESS,
  FETCH_ER_UNIT_FABRICATIONS_FAILURE,
  SAVE_ER_TARGET_DATES_REQUEST,
  SAVE_ER_TARGET_DATES_SUCCESS,
  SAVE_ER_TARGET_DATES_FAILURE,
  FETCH_ER_DELAY_REASONS_REQUEST,
  FETCH_ER_DELAY_REASONS_SUCCESS,
  FETCH_ER_DELAY_REASONS_FAILURE,
  FETCH_ER_DAILY_REMARKS_REQUEST,
  FETCH_ER_DAILY_REMARKS_SUCCESS,
  FETCH_ER_DAILY_REMARKS_FAILURE,
  SAVE_ER_DAILY_REMARK_REQUEST,
  SAVE_ER_DAILY_REMARK_SUCCESS,
  SAVE_ER_DAILY_REMARK_FAILURE,
  FETCH_ER_REMARK_HISTORY_REQUEST,
  FETCH_ER_REMARK_HISTORY_SUCCESS,
  FETCH_ER_REMARK_HISTORY_FAILURE,
} from "../constants/ErectionMonitorConstants";

const initialState = {
  units: [],
  unitsLoading: false,
  unitsError: null,

  fabTypes: [],
  fabTypesLoading: false,
  fabTypesError: null,

  weightsKey: null,
  weights: [],
  weightsLoading: false,
  weightsError: null,

  unitFabricationsKey: null,
  unitFabrications: null, // { IsSaved, ComponentId, IwoNo, UnitId, UnitName, Fabrications: [] }
  unitFabricationsLoading: false,
  unitFabricationsError: null,

  targetSaving: false,
  targetSaveError: null,

  cdlDelayReasons: [],
  dtsDelayReasons: [],
  delayReasonsLoading: false,
  delayReasonsError: null,

  dailyRemarksKey: null, // progressId
  dailyRemarks: [],
  dailyRemarksLoading: false,
  dailyRemarksError: null,

  remarkSaving: false,
  remarkSaveError: null,

  historyKey: null, // "c<componentId>" or "p<progressId>"
  historyRemarks: [],
  historyLoading: false,
  historyError: null,
};

export const ErectionMonitorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ER_UNITS_REQUEST:
      return { ...state, unitsLoading: true, unitsError: null };
    case FETCH_ER_UNITS_SUCCESS:
      return { ...state, units: action.payload || [], unitsLoading: false };
    case FETCH_ER_UNITS_FAILURE:
      return { ...state, units: [], unitsLoading: false, unitsError: action.payload };

    case FETCH_ER_FAB_TYPES_REQUEST:
      return { ...state, fabTypesLoading: true, fabTypesError: null };
    case FETCH_ER_FAB_TYPES_SUCCESS:
      return { ...state, fabTypes: action.payload || [], fabTypesLoading: false };
    case FETCH_ER_FAB_TYPES_FAILURE:
      return { ...state, fabTypes: [], fabTypesLoading: false, fabTypesError: action.payload };

    case FETCH_ER_WEIGHTS_REQUEST:
      return { ...state, weightsKey: action.payload, weights: [], weightsLoading: true, weightsError: null };
    case FETCH_ER_WEIGHTS_SUCCESS:
      if (action.payload.key !== state.weightsKey) return state; // unit changed meanwhile
      return { ...state, weights: action.payload.data, weightsLoading: false };
    case FETCH_ER_WEIGHTS_FAILURE:
      if (action.payload.key !== state.weightsKey) return state;
      return { ...state, weights: [], weightsLoading: false, weightsError: action.payload.message };

    case FETCH_ER_UNIT_FABRICATIONS_REQUEST:
      // same IWO + unit again (refresh after save) -> keep the data on screen while loading
      return {
        ...state,
        unitFabrications: action.payload === state.unitFabricationsKey ? state.unitFabrications : null,
        unitFabricationsKey: action.payload,
        unitFabricationsLoading: true,
        unitFabricationsError: null,
      };
    case FETCH_ER_UNIT_FABRICATIONS_SUCCESS:
      if (action.payload.key !== state.unitFabricationsKey) return state; // IWO / unit changed meanwhile
      return { ...state, unitFabrications: action.payload.data, unitFabricationsLoading: false };
    case FETCH_ER_UNIT_FABRICATIONS_FAILURE:
      if (action.payload.key !== state.unitFabricationsKey) return state;
      return { ...state, unitFabrications: null, unitFabricationsLoading: false, unitFabricationsError: action.payload.message };

    case SAVE_ER_TARGET_DATES_REQUEST:
      return { ...state, targetSaving: true, targetSaveError: null };
    case SAVE_ER_TARGET_DATES_SUCCESS:
      return { ...state, targetSaving: false };
    case SAVE_ER_TARGET_DATES_FAILURE:
      return { ...state, targetSaving: false, targetSaveError: action.payload };

    case FETCH_ER_DELAY_REASONS_REQUEST:
      return { ...state, delayReasonsLoading: true, delayReasonsError: null };
    case FETCH_ER_DELAY_REASONS_SUCCESS:
      return { ...state, cdlDelayReasons: action.payload.cdl, dtsDelayReasons: action.payload.dts, delayReasonsLoading: false };
    case FETCH_ER_DELAY_REASONS_FAILURE:
      return { ...state, delayReasonsLoading: false, delayReasonsError: action.payload };

    case FETCH_ER_DAILY_REMARKS_REQUEST:
      // same stage again (refresh after save) -> keep the list on screen while loading
      return {
        ...state,
        dailyRemarks: action.payload === state.dailyRemarksKey ? state.dailyRemarks : [],
        dailyRemarksKey: action.payload,
        dailyRemarksLoading: true,
        dailyRemarksError: null,
      };
    case FETCH_ER_DAILY_REMARKS_SUCCESS:
      if (action.payload.key !== state.dailyRemarksKey) return state; // stage changed meanwhile
      return { ...state, dailyRemarks: action.payload.data, dailyRemarksLoading: false };
    case FETCH_ER_DAILY_REMARKS_FAILURE:
      if (action.payload.key !== state.dailyRemarksKey) return state;
      return { ...state, dailyRemarks: [], dailyRemarksLoading: false, dailyRemarksError: action.payload.message };

    case SAVE_ER_DAILY_REMARK_REQUEST:
      return { ...state, remarkSaving: true, remarkSaveError: null };
    case SAVE_ER_DAILY_REMARK_SUCCESS:
      return { ...state, remarkSaving: false };
    case SAVE_ER_DAILY_REMARK_FAILURE:
      return { ...state, remarkSaving: false, remarkSaveError: action.payload };

    case FETCH_ER_REMARK_HISTORY_REQUEST:
      return { ...state, historyKey: action.payload, historyRemarks: [], historyLoading: true, historyError: null };
    case FETCH_ER_REMARK_HISTORY_SUCCESS:
      if (action.payload.key !== state.historyKey) return state; // filter changed meanwhile
      return { ...state, historyRemarks: action.payload.data, historyLoading: false };
    case FETCH_ER_REMARK_HISTORY_FAILURE:
      if (action.payload.key !== state.historyKey) return state;
      return { ...state, historyRemarks: [], historyLoading: false, historyError: action.payload.message };

    default:
      return state;
  }
};